import React, { Component } from 'react';
import { Route,BrowserRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import Amplify from 'aws-amplify';
// eslint-disable-next-line
import { Authenticator,Greetings,FederatedSignIn } from 'aws-amplify-react';
import ThetaFederatedSignIn from './components/ThetaFederatedSignIn';
import ThetaBindList from './containers/ThetaBindList';
import ThetaDetecting from './containers/ThetaDetecting';
import { Bootstrap as theme } from './theme';
import { config, federated } from './exports';
import { I18n } from 'aws-amplify';
import { dict } from './dictionary';

Amplify.configure(config);
I18n.putVocabularies(dict);

class ThetaApp extends Component {

  render() {
    if (this.props.authState !== 'signedIn') {
      return null;
    }

    return (
      <div>
      <CssBaseline/>

      <BrowserRouter>
      <div>
      <Route exact path="/" component={ThetaBindList}/>
      <Route exact path="/index.html" component={ThetaBindList}/>
      <Route exact path="/detect" component={ThetaDetecting}/>
      </div>
      </BrowserRouter>
      </div>
    );
  }
}
/* ビルド時はAuthenticator hideDefaultのコメントアウトを外すこと
*/
class AppWithAuth extends Component {
  render(){

    return (
      <div>
      <Authenticator  theme={theme} hideDefault={true} >
        <ThetaFederatedSignIn federated={federated} />
        <ThetaApp />
      </Authenticator>
      </div>
    );
  }
}

export default AppWithAuth;



// WEBPACK FOOTER //
// ./src/App.js